import React from "react";
import { Table, TableHeader, TableBody, TableCell, TableRow } from "@jsq/ds/core";
import * as styles from "../styles_vanilla.css";
import { type TableItemRowDetails } from "../types";

type DataTableProps = {
  rows: TableItemRowDetails[];
};

const DataTable = ({ rows }: DataTableProps) => {
  const allColumns = rows.reduce<Record<string, string>>((columns, row) => {
    const updatedHeadersSet = { ...columns };

    Object.keys(row).forEach((column) => {
      updatedHeadersSet[column] = "";
    });

    return updatedHeadersSet;
  }, {});

  return (
    <div className={styles.dataTableContainer}>
      <Table condensed variant="muted">
        <TableHeader>
          <TableRow>
            {Object.keys(allColumns).map((column) => (
              <TableCell key={column}>{column}</TableCell>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index} data-testid="request-details-row">
              {Object.keys(row).map((columnName) => {
                const columnData = row[columnName];
                return <TableCell key={columnName}>{columnData ?? "--"}</TableCell>;
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default DataTable;
